import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// v6 layout route guard. Renders nested routes via <Outlet/>.
//   needAccess → also requires unexpired paid access (admins bypass).
const Protected = ({ needAccess = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (needAccess && !user.isAdmin && !user.access?.active) {
    return <Navigate to="/subscribe" replace />;
  }

  return <Outlet />;
};

export default Protected;
